import styled from 'styled-components'

import { transition, media } from '../../../../utils/style-utils'

interface Props {
  hover: boolean
}

export const HoverWrapper = styled.div<Props>`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  opacity: 0;

  ${transition('opacity', 0.3)}
  ${({ hover }) => (hover ? 'opacity: 1;' : '')}

  ${media.touch`
    z-index: 1;
    opacity: 0;
  `}
`
